<div class="row mt-5" >
    <div class="col-3 flex">
        <div class="col-lg-3"><img class="patientImg" mat-card-image src="assets/img/patient.png" /></div>
    <div class="col-lg-6 name mt-1" >
      <div class="col-md-12 name">
         {{memberDetails.firstName}}
      </div>
      <div class="col-md-12 age" >
        Age : {{memberDetails.age}}
    </div>
    </div>
    </div>
    
    <div class="col-2 borderClass">
       <div class="col-md-12 name">
        Actual Weight
       </div>
       <div class="col-md-12 age" *ngIf="actualWeight != '[object Object]]'">
        {{actualWeight}} lb
    </div>
    </div>
    
    <!-- <div class="col-2">
        <div class="col-md-12 name">
            Target Weight
           </div>
           <div class="col-md-12 age" >
            50 kg
        </div>
    </div> -->
    
  
  </div>

  <!-- Meal plan macro summary row (shown when view/edit plan API provides meta) -->
  <div class="row mt-2" *ngIf="mealPlanMeta">
    <div class="col-12 planMetaRow">
      <span class="metaItem"><span class="metaLabel">Daily Target:</span> {{mealPlanMeta.calsNeeded}} cal</span>
      <span class="metaSep">|</span>
      <span class="metaItem"><span class="metaLabel">Deficit:</span> {{mealPlanMeta.caloriesDeficitGoal}}</span>
      <span class="metaSep">|</span>
      <span class="metaItem"><span class="metaLabel">Protein:</span> {{mealPlanMeta.proteinGoal}} g</span>
      <span class="metaSep">|</span>
      <span class="metaItem"><span class="metaLabel">Fats:</span> {{mealPlanMeta.fatsGoal}} g</span>
      <span class="metaSep">|</span>
      <span class="metaItem"><span class="metaLabel">Carbs:</span> {{mealPlanMeta.carbsGoal}} g</span>
    </div>
  </div>
 